import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import "../css/others/Table.css";
import { apiCall } from "../main/ApiCall";
import EncryptionUtils from "../main/encryptionUtils";
import { MeetingTracking } from "../interFaces/interfaces";
const MeetingTracker: React.FC = () => {
    const [data, setData] = useState<MeetingTracking[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [fields, setFields] = useState<any>({});
    const navigate = useNavigate();
    const clientId = localStorage.getItem("clientId");
    const columns = [{ key: "campaignName", label: "Campaign Name" }, { key: "accepted", label: "Accepted" }, { key: "declined", label: "Declined" }, { key: "tentative", label: "Tentative" }, { key: "noResponse", label: "No Response" }, { key: "totalMeetings", label: "Total Meetings" }, { key: "totalAttendees", label: "Total Attendees" }];
    useEffect(() => {
        const permissions = EncryptionUtils.get<any>("permissions", null);
        if (permissions.tabs && permissions.tabs["meetingTracker"]) {
            setFields(permissions.tabs["meetingTracker"].fields);
        } else {
            console.log("No permissions found for 'meetingTracker' tab");
        }
    }, []);
    const fetchMeetingTracking = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiCall("get", `/api/meeting-tracking/${clientId}?page=${currentPage - 1}&size=${itemsPerPage}`);
            if (response?.content) {
                setData(response.content);
                setTotalPages(response.totalPages || 0);
                setTotalElements(response.totalElements || 0);
            } else if (Array.isArray(response)) {
                setData(response);
                setTotalPages(1);
                setTotalElements(response.length);
            }
        } catch (error) {
            console.error("Error fetching meeting tracking data:", error);
        } finally {
            setLoading(false);
        }
    }, [clientId, currentPage, itemsPerPage]);
    useEffect(() => {
        fetchMeetingTracking();
    }, [fetchMeetingTracking]);
    const handleCampaignClick = (campaignId: string) => {
        navigate(`/meetingtrackerdetails/${campaignId}`);
    };
    return (
        <div className="table-details">
            <div className="table-title">
                <h2>Meeting Tracker</h2>
            </div>
            <div className="table-container">
                <div className="table-inner-container">
                    <table className="main-table">
                        <thead>
                            <tr>
                                {columns.map(col => (
                                    <th key={col.key}>{col.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={columns.length} className="no-data">Loading...</td>
                                </tr>
                            ) : data.length > 0 ? (
                                data.map(item => (
                                    <tr key={item.campaignId}>
                                        {fields.view && (<td className="clickable" onClick={() => handleCampaignClick(item.campaignId)}>{item.campaignName}</td>)}
                                        <td>{item.accepted}</td>
                                        <td>{item.declined}</td>
                                        <td>{item.tentative}</td>
                                        <td>{item.noResponse}</td>
                                        <td>{item.totalMeetings}</td>
                                        <td>{item.totalAttendees}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length} className="no-data">No meeting tracking data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
        </div>
    );
};
export default MeetingTracker;